import _ from 'lodash';

const state = {
  read: {},
  favorites: [],
  layout: 'list',
  categories: [],
  collection: [],
  page: 2,
};

const getters = {
  getPropertiesRead: (state) => state.all,
  getPropertiesFavorites: (state) => state.favorites,
  getPropertiesLayout: (state) => state.layout,
  getPropertiesCategories: (state) => state.categories,
  getPropertiesCollection: (state) => state.collection,
  getPropertiesPage: (state) => state.page,
};

const actions = {
  /* getProperties ({ commit }) {
    shop.getProducts(products => {
      commit(types.RECEIVE_PRODUCTS, { products })
    })
  } */
};

const mutations = {
  SET_PROPERTIES_READ(state, data) {
    state.read = data;
  },
  SET_PROPERTIES_FAVORITES(state, data) {
    state.favorites = data;
  },
  SET_PROPERTIES_LAYOUT(state, type) {
    state.layout = type;
  },
  SET_PROPERTIES_CATEGORIES(state, data) {
    state.categories = data;
  },
  SET_PROPERTIES_COLLECTION(state, data) {
    state.collection = data;
  },
  PUSH_TO_PROPERTIES_COLLECTION(state, data) {
    _.each(data, (item) => {
      state.collection.push(item);
    });
  },
  INCREASE_PROPERTIES_PAGE(state) {
    state.page = state.page + 1;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/properties.js